// extracted by mini-css-extract-plugin
export var herocontainer = "hero-module--herocontainer--U54OO";
export var root = "hero-module--root--SkPT9";
export var heading = "hero-module--heading--yYMwf";
export var secondaryHeading = "hero-module--secondaryHeading--fENoL";
export var buttonContainer = "hero-module--buttonContainer--hK6fQ";
export var content = "hero-module--content--qPvtG";
export var image = "hero-module--image--cQhrJ";